/**
* Testimonials Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'testimonials-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      slickTestimonials();

      $( window ).on( 'resize', function() {
        slickTestimonials();
      } );
      $( '.ll_testimonial_close' ).on( 'click', function( e ) {
        e.preventDefault();
        $( '.mfp-close' ).click();
      } );
      function slickTestimonials() {
        $( '.testimonials-slider' ).each( function() {
          if ( $( this ).find( '.testimonial' ).length > 3 ) {
            const heights = $( this ).find( '.testimonial-inner__wrapper' ).map( function() {
              return $( this ).height();
            } );
            const loanTypeHeights = $( this ).find( '.loan-types' ).map( function() {
              return $( this ).height();
            } );
            const maxHeight = Math.max.apply( null, heights );
            const maxLoanHeight = Math.max.apply( null, loanTypeHeights );
            $( this ).find( '.testimonial-container' ).css( {'grid-template-rows': `${maxHeight}px ${maxLoanHeight}px`} );
            $( this ).find( '.slider' ).slick( {
              dots: false,
              arrows: true,
              prevArrow: $( this ).find( '.prev-slide' )[0],
              nextArrow: $( this ).find( '.next-slide' )[0],
              slidesToShow: 3,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
            } );
          } else {
            if ( window.innerWidth < 1024 ) {
              $( this ).find( '.slider' ).slick( {
                dots: false,
                arrows: true,
                prevArrow: $( this ).find( '.prev-slide' )[0],
                nextArrow: $( this ).find( '.next-slide' )[0],
                slidesToShow: 1,
              } );

              $( this ).find( '.slider-buttons' ).removeClass( 'hidden' ).addClass( 'flex' );
            } else {
              $( this ).find( '.slider.slick-slider' ).slick( 'unslick' );
              $( this ).find( '.slider-buttons' ).addClass( 'hidden' ).removeClass( 'flex' );
            }
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials-slider', COMPONENT );
} )( app );
